var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6419 20.1797V24.1083H14.2237L15.3205 20.1797H19.6419ZM24.6777 20.1797L25.7741 24.1083H20.3562V20.1797H24.6777ZM14.0244 24.8225H25.9737L26.6716 27.3225H13.3266L14.0244 24.8225ZM27.413 27.3225L25.4194 20.1797H27.2491L29.6719 26.8433C29.7118 26.9527 29.6957 27.0747 29.629 27.1702C29.5622 27.2656 29.4531 27.3225 29.3366 27.3225H27.413ZM24.4884 12.9058L25.8102 16.2511H24.3234L23.3266 12.6797H24.1562C24.3029 12.6797 24.4346 12.7694 24.4884 12.9058ZM16.4159 16.2511L16.9159 14.4654H19.6419V16.2511H16.4159ZM22.5852 12.6797L22.8844 13.7511H17.1137L17.413 12.6797H22.5852ZM20.3562 14.4654H23.0837L23.5837 16.2511H20.3562V14.4654ZM15.8423 12.6797H16.6716L15.6748 16.2511H14.1884L15.5098 12.9058C15.5637 12.7692 15.6955 12.6796 15.8423 12.6797ZM12.1419 17.3225C12.1419 17.1253 12.3018 16.9654 12.4991 16.9654H27.4991C27.6963 16.9654 27.8562 17.1253 27.8562 17.3225V19.1083C27.8562 19.3055 27.6963 19.4654 27.4991 19.4654H12.4991C12.3018 19.4654 12.1419 19.3055 12.1419 19.1083V17.3225ZM12.7491 20.1797H14.5787L12.5852 27.3225H10.6616C10.5451 27.3225 10.436 27.2656 10.3692 27.1702C10.3024 27.0747 10.2864 26.9527 10.3262 26.8433L12.7491 20.1797Z",
    fill: "#27A376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.9be6299a1defd76fa7da42c907cda2ed.svg";
export { ForwardRef as ReactComponent };